import React, { useState } from 'react';
import styled from '@emotion/styled';
import { BREAKPOINTS, COLORS_BASE, GLOBAL_SIZES } from '../../utils/consts';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faTimes } from '@fortawesome/free-solid-svg-icons';

import Container from '../Shared/Container';
import AppName from './AppName';
import Menu from './Menu';
import { LogoStyle } from '../../styles/styles';

function Nav() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <Container margin='0px' flex padding="0 25px" height={`${GLOBAL_SIZES.NAV}px`} borderRadius='0px'>
      <NavStyle>
        <AppName />
        <DesktopMenuWrapper>
          <Menu />
        </DesktopMenuWrapper>
        <RightActions>
          <LogoStyle src='/logos/logo-doe.png' alt="Portal Logo" />
          <MobileMenuButton
            type="button"
            aria-label={isMobileMenuOpen ? 'Close navigation menu' : 'Open navigation menu'}
            aria-expanded={isMobileMenuOpen}
            onClick={() => setIsMobileMenuOpen((prev) => !prev)}
          >
            <FontAwesomeIcon icon={isMobileMenuOpen ? faTimes : faBars} />
          </MobileMenuButton>
        </RightActions>
      </NavStyle>
      <MobileMenuPanel isOpen={isMobileMenuOpen}>
        <Menu vertical onNavigate={() => setIsMobileMenuOpen(false)} />
      </MobileMenuPanel>
    </Container>
  );
}

export default Nav;

const NavStyle = styled.nav<{}>(() => `
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  display: flex;  
  justify-content: space-between;
  justify-items: center;
  color: 'black';
  gap: 16px;
`);

const DesktopMenuWrapper = styled.div`
  margin-right: auto; /* Pushes the Menu to the right */

  @media (max-width: ${BREAKPOINTS.MOBILE}) {
    display: none;
  }
`;

const RightActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  img {
    @media (max-width: ${BREAKPOINTS.MOBILE}) {
      width: 2.8rem;
      padding: 0.5rem;
    }
  }
`;

const MobileMenuButton = styled.button`
  display: none;
  width: 42px;
  height: 42px;
  border-radius: 999px;
  background: ${COLORS_BASE.BRAND.MAIN};
  color: white;
  align-items: center;
  justify-content: center;

  @media (max-width: ${BREAKPOINTS.MOBILE}) {
    display: inline-flex;
  }
`;

const MobileMenuPanel = styled.div<{ isOpen: boolean }>(({ isOpen }) => `
  display: none;

  @media (max-width: ${BREAKPOINTS.MOBILE}) {
    display: ${isOpen ? 'block' : 'none'};
    position: fixed;
    top: ${GLOBAL_SIZES.NAV}px;
    left: 0;
    right: 0;
    background: white;
    border-top: 1px solid ${COLORS_BASE.GREYS.HIGHLIGHT};
    box-shadow: 0 12px 30px rgba(0, 0, 0, 0.12);
    z-index: 120;
  }
`);
